import { render, staticRenderFns } from "./WrsSearchButtons.vue?vue&type=template&id=5e87fadc&"
import script from "./WrsSearchButtons.vue?vue&type=script&lang=js&"
export * from "./WrsSearchButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports